import { WorkflowTemplateStatus } from '../Types'

const marketing: WorkflowTemplateStatus = {
  configuration: {
    'f32ec942-939a-46f5-9c7d-e0329a16ec6c': {
      exit: [],
      entry: [],
    },
    '2dc6aa07-900d-43ec-924a-972f08f63091': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'reviews.create',
          config: {},
        },
      ],
    },
    '71be98c1-50a1-41d7-8f14-bf6118ab4f1e': {
      exit: [],
      entry: [],
    },
    'a41f1962-bdb4-4ea1-9323-2b2296032af9': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'reviews.create',
          config: {},
        },
      ],
    },
    '841a5c92-3de8-4389-9d89-edd327850143': {
      exit: [],
      entry: [],
    },
    '1b64350e-3031-4971-ad67-70fbab387421': {
      exit: [
        {
          type: 'reviews.close',
          config: {},
        },
      ],
      entry: [
        {
          type: 'read_receipts.create',
          config: {},
        },
      ],
    },
    '3ec330e8-0a33-47df-b17b-b33e5d87ab47': {
      exit: [],
      entry: [],
    },
    '05f8ebc5-4d74-4b1b-bd72-2c2e81e43d3f': {
      exit: [],
      entry: [],
    },
  },
  property_values: [
    {
      uuid: 'f32ec942-939a-46f5-9c7d-e0329a16ec6c',
      value: 'Draft',
      meta: {
        color: '#283144',
      },
      position: 0,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '2dc6aa07-900d-43ec-924a-972f08f63091',
      value: 'Manager Review',
      meta: {
        color: '#EBDCFF',
      },
      position: 1,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '71be98c1-50a1-41d7-8f14-bf6118ab4f1e',
      value: 'Manager Reviewed',
      meta: {
        color: '#8626FF',
      },
      position: 2,
      connected_to_uuid: '2dc6aa07-900d-43ec-924a-972f08f63091',
      connected_to_id: null,
    },
    {
      uuid: 'a41f1962-bdb4-4ea1-9323-2b2296032af9',
      value: 'Leadership Review',
      meta: {
        color: '#FFD74A',
      },
      position: 3,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '841a5c92-3de8-4389-9d89-edd327850143',
      value: 'Leadership Reviewed',
      meta: {
        color: '#F3A100',
      },
      position: 4,
      connected_to_uuid: 'a41f1962-bdb4-4ea1-9323-2b2296032af9',
      connected_to_id: null,
    },
    {
      uuid: '1b64350e-3031-4971-ad67-70fbab387421',
      value: 'Sent to company',
      meta: {
        color: '#75E5A2',
      },
      position: 5,
      connected_to_uuid: null,
      connected_to_id: null,
    },
    {
      uuid: '3ec330e8-0a33-47df-b17b-b33e5d87ab47',
      value: 'Final',
      meta: {
        color: '#07BA4F',
      },
      position: 6,
      connected_to_uuid: '1b64350e-3031-4971-ad67-70fbab387421',
      connected_to_id: null,
    },
    {
      uuid: '05f8ebc5-4d74-4b1b-bd72-2c2e81e43d3f',
      value: 'Deprecated',
      meta: {
        color: '#FFCBCB',
      },
      position: 7,
      connected_to_uuid: null,
      connected_to_id: null,
    },
  ],
}

export default marketing
